
<!-- Modal -->
<div class="modal fade" *ngIf="adminApi.isLoggedIn()" id="{{modalid}}" tabindex="-1" aria-labelledby="suggestskillModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <form class="" [formGroup]="Form" (ngSubmit)="onSubmit(Form)">
        <div class="modal-body pt-4">
          <h5 class="card-title">{{user?  "Edit User":""}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="row">
            <div class="col-md-12 form-group">
              <label for="validationFirstName" class="form-label">First name</label>
              <input type="text" class="form-control" id="validationFirstName" formControlName="first_name" value="">
              <div class="invalid-feedback d-block"
                  *ngIf="f2['first_name'].errors?.['required'] && (f2['first_name'].dirty || f2['first_name'].touched)">
                  Please fill first name.
              </div>
            </div>
            <div class="col-md-12 form-group">
              <label for="validationLastName" class="form-label">Last name</label>
              <input type="text" class="form-control" id="validationLastName" formControlName="last_name" value="">
              <div class="invalid-feedback d-block"
                  *ngIf="f2['last_name'].errors?.['required'] && (f2['last_name'].dirty || f2['last_name'].touched)">
                  Please fill last name.
              </div>
            </div>
            <div class="col-md-12 form-group">
              <label for="validationDOB" class="form-label">Date of Birth</label>
              <div class="input-group">
                  <input type="text" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" formControlName="dob" class="form-control mb-0" placeholder="DOB"
                      aria-label="DOB">
                  <div class="input-group-append d-flex" [owlDateTimeTrigger]="dt2">
                      <span class="input-group-text rounded-0"><i class="fa fa-calendar"></i></span>
                  </div>
              </div>
              <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
              <div class="invalid-feedback d-block"
                  *ngIf="f2['dob'].errors?.['required'] && (f2['dob'].dirty || f2['dob'].touched)">
                  Please select dob.
              </div>
              <div class="invalid-feedback d-block"
                  *ngIf="f2['dob'].errors?.['futureDate'] && (f2['dob'].dirty || f2['dob'].touched)">
                  Date of birth cannot be in the future.
              </div>
            </div>
            <div class="col-md-12 form-group">
              <label for="validationCountry" class="form-label">Country</label>
              <select class="form-select" formControlName="country" id="validationCountry">
                <option value="">Choose...</option>
                <ng-container  *ngFor="let country of countries">
                    <option value="{{country.code}}">{{country.name}}</option>
                </ng-container>
              </select>
              <div class="invalid-feedback d-block"
                  *ngIf="f2['country'].errors?.['required'] && (f2['country'].dirty || f2['country'].touched)">
                  Please select country.
              </div>
            </div>
            <div class="col-md-12 form-group mb-0" *ngIf="user && (user.role=='gymowner' || user.role=='choreographer')">
              <label for="validationDefaultGym" class="form-label">Gym / Team Name</label>
              <input type="text" class="form-control" formControlName="gym_name" id="validationDefaultGym" value="">
              <div class="invalid-feedback d-block"
                  *ngIf="f2['gym_name'].errors?.['required'] && (f2['gym_name'].dirty || f2['gym_name'].touched)">
                  Please fill gym name.
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-dark btn-gold">Submit <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </form>
    </div>
  </div>
</div>
